var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-card flex-box align-center",class:[_vm.size],style:({ '--gap': _vm.gap + 'px' })},_vm._l((_vm.list),function(item){return _c('div',{key:item.value,staticClass:"card-tab-item",class:{ active: item.value === _vm.value },on:{"click":function($event){return _vm.selectTab(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }